import { render, staticRenderFns } from "./AgregarTrabajador.vue?vue&type=template&id=5bcc7374&"
import script from "./AgregarTrabajador.vue?vue&type=script&lang=js&"
export * from "./AgregarTrabajador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports